/***
*
*   HOME NAV
*   Navigation used on the main external website. Renders a dashboard link
*   if the user is signed in, or a sign up link if they are not
*
**********/

import React, { Fragment, useContext } from 'react';
import ClassNames from 'classnames';
import { AuthContext, Link, Content } from 'components/lib';
import Style from './home.module.scss';

export function HomeNav(props){

  // context
  const context = useContext(AuthContext);

  // style
  const css = ClassNames([

    Style.nav,
    props.transparent && Style.transparent

  ]);

  return(
    <section className={ css }>
      <Content>

        <a href="https://ledgerview.app"><span className={ Style.logo } style={{color: '#ffffff', font: 'Arial', fontSize: 28, textDecoration: 'none'}}>LedgerView</span></a>
        <nav>

          { context.user?.token ?
            <Link url='/dashboard' text='Dashboard' /> :
            <Fragment>
              <Link url='https://ledgerview.app' text='Home' />
              <Link url='/signin' text='Sign In' />
              <Link url='/signup' text='Sign Up' />
            </Fragment>
          }
        </nav>
      </Content>
    </section>
  );
}
